// Shared code snippets for onboarding UI

import { queryOptions } from '@tanstack/react-query';
import { highlightCode } from '@/lib/shiki';

export function getSdkCommitSnippet(repo: string): string {
  return `import { Mesa } from "@mesadev/sdk";

const mesa = new Mesa({ privateKey: process.env.MESA_PRIVATE_KEY });

const repoInfo = await mesa.repos.get({
  repo: "${repo}",
});

const change = await mesa.changes.create({
  repo: "${repo}",
  base_change_id: repoInfo.head_change_id!,
  message: "Initial change",
  authors: [{ name: "Agent", email: "agent@example.com" }],
  files: [
    { path: "README.md", action: "upsert", content: Buffer.from("# ${repo}").toString("base64"), encoding: "base64" }
  ]
});

await mesa.bookmarks.move({
  repo: "${repo}",
  bookmark: "main",
  change_id: change.id,
});`;
}

export const SDK_INSTALL_SNIPPET = 'npm install @mesadev/sdk';

// Module-level cache: these snippets are static strings, so Shiki only needs to
// run once per Lambda instance instead of on every request.
let cachedSnippets: { installSnippetHtml: string; sdkSnippetHtml: string } | null = null;

export const repoSnippetsQueryOptions = () =>
  queryOptions({
    queryKey: ['repo-snippets'],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      if (cachedSnippets) return cachedSnippets;
      const [installSnippetHtml, sdkSnippetHtml] = await Promise.all([
        highlightCode(SDK_INSTALL_SNIPPET, 'bash'),
        highlightCode(getSdkCommitSnippet('REPO'), 'typescript'),
      ]);
      cachedSnippets = { installSnippetHtml, sdkSnippetHtml };
      return cachedSnippets;
    },
  });
